import { AuthLayout, GameLayout } from '@root/layout';
import { createGameApp } from '@shared/app';

export default createGameApp({ AuthLayout, GameLayout });
